import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";

import { MEDIA_THUMBNAIL_URL, PLACEHOLDER_IMG_360x360_URL } from "../../config";

import StatusChip from "./StatusChip";

const useStyles = makeStyles({
  root: {
    width: 200,
    margin: "20px",
  },
  media: {
    height: 110,
  },
});

export default function TravelCardSimple({ travelCard }) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardMedia
        className={classes.media}
        image={
          !!travelCard.mediaId
            ? `${MEDIA_THUMBNAIL_URL}/${travelCard.mediaId}?width=240`
            : PLACEHOLDER_IMG_360x360_URL
        }
        title={travelCard.name}
      />
      <CardContent>
        <Typography
          gutterBottom
          variant="subtitle2"
          component={RouterLink}
          style={{ color: "#fff", textDecoration: "none" }}
          to={`/travel-card/${travelCard.id}`}
        >
          {travelCard.name}
        </Typography>

        <StatusChip status={travelCard.status} />
      </CardContent>
    </Card>
  );
}
